import * as React from 'react';

// Component
import { GenericPopup } from '@shopee-user/shared-customization-ui';

// Utils
import cx from 'classnames';

// Styles
import styles from './styles.scss';

// Types
import { DialogProps } from '@shopee-user/business-customization-types';

const Dialog = ({
  shouldShow,
  title,
  content,
  primaryActionText,
  secondaryActionText,
  onClickPrimary,
  onClickSecondary,
  disablePrimary,
  disableSecondary,
  hideSecondary,
  contentClassName,
  containerClassName,
  onClose,
  contentRef,
}: DialogProps) => {
  return (
    <GenericPopup shouldShow={shouldShow} showOverlay={true} onClose={onClose}>
      <div className={cx(styles.container, containerClassName)}>
        <div className={styles.titleAndContentContainer}>
          {title && (
            <div
              className={cx(styles.title, {
                [styles.titleNoContent]: !content,
              })}
            >
              {title}
            </div>
          )}
          {content && (
            <div
              className={cx(styles.content, contentClassName, {
                [styles.contentNoTitle]: !title,
              })}
              ref={contentRef}
            >
              {content}
            </div>
          )}
        </div>

        <div className={styles.buttonContainer}>
          {!hideSecondary && (
            <div
              onClick={!disableSecondary ? onClickSecondary : undefined}
              className={cx(styles.secondaryButton, {
                [styles.buttonDisabled]: disableSecondary,
              })}
            >
              {secondaryActionText}
            </div>
          )}
          <div
            onClick={!disablePrimary ? onClickPrimary : undefined}
            className={cx(styles.primaryButton, {
              [styles.buttonDisabled]: disablePrimary,
            })}
          >
            {primaryActionText}
          </div>
        </div>
      </div>
    </GenericPopup>
  );
};

export default Dialog;
